<script>
import { computed, onMounted, ref } from '@vue/composition-api'
// 普通答题
import getCountDown from './countdown'
import CommonQue from './CommonQue.vue'
import { formatTime } from '@/utils/time'
import DingzhenQue from './DingzhenQue.vue'
import { EXTRA_TIME } from './constant'
import ClassBtn from './ClassBtn.vue'
export default {
  name: 'NormalQue',
  components: {
    ClassBtn,
    CommonQue,
    DingzhenQue
  },
  props: {
    event: Object
  },
  setup(props, { root, refs, emit }) {
    const commonQue = ref(null)
    function realEnd() {
      emit('realEnd')
    }
    function end() {
      emit('end')
    }
    // 显示时长为生产平台实际配置时长单位秒+3s反馈时长
    const { countdown, start } = getCountDown(EXTRA_TIME)
    const params = computed(() => props.event.params)
    const duration = computed(() => params.value.duration)

    const countdownDesc = computed(() => formatTime(countdown.value, 'mm:ss'))

    function refreshQue() {
      commonQue.value.getDiy()
    }

    onMounted(() => {
      const { event } = props
      const { params } = event
      const { duration } = params
      start(duration, () => {
        // TODO 倒计时结束如何处理
        // emit("resume", event)
      })
    })
    return {
      realEnd,
      end,
      duration,
      countdownDesc,
      refreshQue,
      params
    }
  }
}
</script>
<template>
  <div>
    <!-- 定帧题 -->
    <DingzhenQue :event="event" @realEnd="realEnd" @end="end" v-if="params.source === 3" />
    <!-- 题库题和普通答题 -->
    <div v-else class="normal-que">
      <p class="que-title">
        <span class="title">学员正在参与普通答题互动</span>
        <!-- 如果有倒计时显示，不配置时不显示 -->
        <span v-if="duration" class="countdown-wrap">
          <i class="iconfont icon-shijian" />
          {{ countdownDesc }}
        </span>
      </p>
      <CommonQue ref="commonQue" :params="params" />
      <div class="que-bottom">
        <!-- 只有题库题才有刷新 -->
        <div>
          <span @click="refreshQue" v-if="params.source === 1" class="iconfont icon-shuaxin" />
        </div>
        <ClassBtn @realEnd="realEnd" @end="end" />
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.normal-que {
  width: 680px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 0 24px;
  .que-title {
    height: 78px;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 20px;
    color: #3e416d;
    justify-content: space-between;
    .title {
      font-weight: bold;
    }
  }
  .countdown-wrap {
    display: flex;
    align-items: center;
    color: #1e96fe;
  }
  .icon-shijian {
    font-size: 30px;
    margin-right: 4px;
  }
  .que-bottom {
    padding: 16px 0 24px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-shuaxin {
      font-size: 30px;
      color: #70788c;
      padding: 9px;
      cursor: pointer;
    }
  }
  .bottom-btn {
    width: 106px;
    height: 48px;
    background: #3262fd;
    border: none;
    box-shadow: 0px 2px 4px rgba(70, 28, 255, 0.2), 0px 8px 16px rgba(67, 24, 255, 0.1);
    border-radius: 8px;
    font-weight: bold;
    font-size: 16px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
</style>
